import { companySections } from './company-sections.js';
import { documentationPageHelp, type DocumentationPageKey } from './system-documentation-flows.js';

/// Qual página da empresa o endereço mostra. Telas de detalhe (uma cliente, um pacote, um
/// atendimento) compartilham a ajuda da lista de onde vieram. A própria Ajuda não tem ícone.
export function pageKeyOf(pathname: string, companyKey: string): DocumentationPageKey | null {
  const prefix = `/companies/${companyKey}`;
  if (!pathname.startsWith(prefix)) return null;
  const rest = pathname.slice(prefix.length).replace(/\/+$/u, '');
  if (rest === '') return 'home';
  if (rest === '/sales/new') return 'new-sale';
  if (/^\/clients\/[^/]+$/u.test(rest)) return 'client';
  if (/^\/packages\/[^/]+$/u.test(rest)) return 'package';
  if (/^\/scheduling\/appointments\/[^/]+\/closing$/u.test(rest)) return 'closing';
  if (rest === '/settings/appearance') return 'appearance';
  if (rest === '/settings/security') return 'security';
  if (rest.startsWith('/communication')) return 'communication';
  const section = companySections.find(
    (item) => item.to.slice('/companies/$companyKey'.length) === rest,
  );
  return section && section.key in documentationPageHelp
    ? (section.key as DocumentationPageKey)
    : null;
}
